// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Styled from './RedoSearchButton.styles';
import SVGIcon from '../../SVGIcon';
import { colors } from '../../css';

const { colorWhite } = colors;

class RedoSearchButton extends Component {
  static propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string,
    ref: PropTypes.func
  };

  static defaultProps = {
    label: 'Search This Area',
    icon: 'search',
    ref: undefined
  };

  render() {
    const { label, icon, ref, ...otherProps } = this.props;
    const props = {
      pill: true
    };
    if (ref) {
      Object.assign(props, { ref });
    }

    return (
      <Styled.Button {...otherProps} {...props}>
        <span className="label">{label}</span>

        <SVGIcon selectedIcon={icon} iconColor={colorWhite} />
      </Styled.Button>
    );
  }
}

export default RedoSearchButton;
